import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ca220b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "log-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Log ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Close ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx._visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx._visible) = $event)),
    onCancel: _ctx.handleCancel,
    width: "50%"
  }, {
    title: _withCtx(() => [
      _hoisted_2
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.handleCancel
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_table, {
          columns: _ctx.logColumns,
          pagination: false,
          dataSource: _ctx.logData,
          rowKey: "id",
          scroll: { y: 400 },
          bordered: ""
        }, {
          creatAt: _withCtx(({ record }) => [
            _createElementVNode("span", null, _toDisplayString(typeof record.creatAt === "string"
              ? record.creatAt.replace(/\-/g, "/")
              : record.creatAt), 1)
          ]),
          _: 1
        }, 8, ["columns", "dataSource"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}